import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-poh',
  templateUrl: './poh.component.html',
  styleUrls: ['./poh.component.css']
})
export class PohComponent implements OnInit {
    webPageName;

    pohKeyno;

    public selectedBgPohMain: string = 'COMPONENTS';

    public menu?: Menu;

    public itemsListComponents: Item[] = [];

    public itemsListProductionOrders: Item[] = [];

    public gridProductionOrders?: GridOptions;

    public changeStatusText: string = '';

    public goingToPoFinish = false;

    public changeStatusDisabled = true;

    public cancellingCaseQtyOl = false;

    public cancellingCaseQty = false;

    public changingStatus = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.webPageName = this.stateService.getCurrentName();
        this.pohKeyno = this.stateService.getStateParams()['poh_keyno'];
    }

    private async loadMenu() {
        if (!!this.pohKeyno) {
            this.menu = (await this.datatask.Post(1353, { poh_keyno: this.pohKeyno }))[0];
        }
    }

    private async loadComponents() {
        if (!!this.menu) {
            this.itemsListComponents = await this.datatask.Post(1355, { poh_keyno: this.menu.poh_keyno });
        }
    }

    private async loadProductionOrders() {
        if (!!this.menu) {
            this.itemsListProductionOrders = await this.datatask.Post(1993, { poh_keyno: this.menu.poh_keyno });
        }
    }

    private async retrieveStatusBtnState() {
        if (!!this.menu) {
            const response = await this.datatask.Post(2440, {
                state: 'current',
                poh_keyno: this.menu.poh_keyno
            });
            
            this.changeStatusText = response?.text;
            this.changeStatusDisabled = response?.disabled;
        }
    }

    private loadGridProductionOrders() {
        if (!!this.menu) {
            if (!this.gridProductionOrders) {
                this.gridProductionOrders = new Grid()
                    .setRememberId('w_poh.poh_keyno')
                    .setLoadDataFunction({
                        method: 2320,
                        parameters: { poh_keyno: this.menu.poh_keyno }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.gridProductionOrders?.gridfunc?.read();
            }
        }
    }

    public async cancelCaseQtyOl() {
        if (!!this.menu) {
            try {
                this.cancellingCaseQtyOl = true;

                const response = await this.datatask.Post(2321, { poh_keyno: this.menu.poh_keyno });

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.cancellingCaseQtyOl = false;
            }
        }
    }

    public async cancelCaseQty() {
        if (!!this.menu) {
            try {
                this.cancellingCaseQty = true;

                const response = await this.datatask.Post(2322, { poh_keyno: this.menu.poh_keyno });

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.cancellingCaseQty = false;
            }
        }
    }

    public async changeStatus() {
        if (!!this.menu) {
            try {
                this.changingStatus = true;

                const response = await this.datatask.Post(2440, {
                    state: 'update',
                    poh_keyno: this.menu.poh_keyno
                });

                this.changeStatusText = response?.text;
                this.changeStatusDisabled = response?.disabled;

                if (response?.errorcode !== null) {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.changingStatus = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2427, { poh_keyno: this.menu.poh_keyno }))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back(2);
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public async goToFunc(state: any) {
        switch (state) {
            case 'pofinishprod':
                if (!!this.menu) {
                    try {
                        this.goingToPoFinish = true;

                        const response = (await this.datatask.Post(3206, { poh_keyno: this.menu.poh_keyno }))[0];

                        if (response?.p2_pofinishprod_keyno && response?.p2_pofinishprod_keyno !== '0') {
                            this.stateService?.go('pofinishprod', {
                                p2_pofinishprod_keyno: Number.parseInt(response?.p2_pofinishprod_keyno),
                                po_keyno: Number.parseInt(response?.po_keyno)
                            });
                        }
                    } finally {
                        this.goingToPoFinish = false;
                    }
                }
                break;
            case 'selectreport':
                this.stateService?.go('selectreport', {
                    webpage_name: this.webPageName,
                    argtype: 'poh_keyno',
                    argvalue: this.menu?.poh_keyno
                });
                break;
            case 'emailcreate':
                this.stateService?.go('emailcreate', {
                    webpage: this.webPageName,
                    argtype: 'poh_keyno',
                    argvalue: this.menu?.poh_keyno
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadComponents();
        this.loadProductionOrders();
        this.retrieveStatusBtnState();
        this.loadGridProductionOrders();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    poh_keyno: number;
    stockplace_name: string;
    poh_keyno_top: number;
    show_setting: string;
    setting_show_pohfinish_create: string;
}
